import { useParams } from 'react-router-dom';
import {
  Button,
  Container,
  Grid,
  Typography,
} from '@mui/material';

import Layout from 'lib/components/Layout';
import { logAnalyticsEvent } from 'lib/firebase/analytics';

import { base } from 'themes';
import { Logo } from 'components/icons';
import { FOOTER_PROPS } from 'constants';

import SetCompletion from 'components/SetCompletion';

import CardsExplorer from './CardsExplorer';

import { useSet, useData } from 'hooks';

const mergeCards = ({ cards, data }) => {
  if (!cards || !data) return [];

  const merged = cards.map((card) => {
    const match = data.find((d) => d.collectorNumber === card.collectorNumber);
    return {
      ...card,
      ...match,
      selected: card.selected || false,
    };
  });

  return merged;
};

export default function SetProgressPage() {
  const {setCode} = useParams();
  const [set, cards] = useSet(setCode);
  const [data] = useData(`tcgist/sets/${setCode}`, []);

  const allCards = mergeCards({ cards, data });

  return (
    <Layout
      theme={base}
      footerProps={FOOTER_PROPS}
      navbarProps={{
        logo: (<Logo />),
        right: (
          <Button
            href="https://szk4u.mjt.lu/wgt/szk4u/xu59/form?c=0799e44b"
            target="_blank"
            variant="contained"
            onClick={() => logAnalyticsEvent('click', { label: 'Try TCGist' })}
          >
            Try TCGist
          </Button>
        )
      }}
    >
      <Container sx={{ pt: 15 }}>
        <Typography variant="h4">
          {set.name} Set Completion
        </Typography>
        <Grid container spacing={4} py={3}>
          <Grid item xs={12} sm={5} md={4}>
            <Grid container spacing={2} style={{ position: "sticky", top: 80 }}>
              <Grid item xs={12}>
                <SetCompletion set={set} cards={allCards} />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={7} md={8}>
            <CardsExplorer
              cards={allCards}
              onCardSelected={() => {console.log('Card selected');}}
            />
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};
